export default __webpack_public_path__ + "static/media/icon-chevron.5dc5eac2.svg";